<template>
    <b-container class="nav-bar">
        <b-navbar 
            v-b-scrollspy="{offset:10, method:'auto'}"
            toggleable="md" 
            type="dark" 
            variant="dark" 
            fixed="top"
            class="shadow-sm pl-md-4 pr-md-4"
        >
            <b-navbar-brand v-scroll-to="'#page-top'" class="font-weight-bolder">EventPass</b-navbar-brand>
            <b-navbar-nav>
                <b-nav-text><WhatsAppIcon v-if="whatsAppModule && whatsAppModule.active ===1" :init_data="wappData"/></b-nav-text>
            </b-navbar-nav>

            <b-navbar-toggle 
                v-if="isLoggedIn && ($route.name === 'Home' || $route.name === 'OnSite')"
                target="nav-collapse" 
                class="bg-dark pt-2 pb-2 border-light" 
                @click="visible = !visible"
            >
                <template v-slot:default="{ }">
                    <b-icon icon="list" variant="light" font-scale="1"></b-icon> <small class="text-light">Menu</small>
                </template>
            </b-navbar-toggle>
            

            <b-collapse 
                id="nav-collapse" 
                v-model="visible" 
                is-nav 
                :class="{'bg-white shadow-sm pl-2 pr-2':visible}"
            >
                <b-navbar-nav class="ml-auto">
                    <b-nav-item v-if="isLoggedIn" @click="showMyInfo">Mis Datos</b-nav-item>
                    <b-nav-item v-if="isLoggedIn" @click="endSession">Olvidarme</b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </b-container>
</template>

<script>
import Vue from 'vue'
import WhatsAppIcon from '@/components/WhatsAppIcon/WhatsAppIcon.vue'

export default Vue.extend({
    name: 'NavBar',
    data() {
        return {
            visible: false,
        }
    },
    components: {
        WhatsAppIcon
    },
    methods: {
        showMyInfo() {
            this.$eventHub.$emit('showMsgBox', {title: 'Mis Datos', text: '(' + this.assistant.email + ') ' +this.assistant.name})
        },
        endSession() {
            this.$eventHub.$emit('unsuscribeProtectChannel')
        },
    },
    computed: {
        isLoggedIn : function() {
            return this.$store.getters.isLoggedIn
        },
        eventFinished : function() {
            return !this.$store.getters.eventFinished
        },
        wappData: function() {
            return JSON.parse(this.whatsAppModule.params)
        },
        whatsAppModule : function() { return this.$store.getters.getModule('WhatsApp') },
        assistant : function() { return this.$store.getters.assistant },
    },
    mounted() {
        
    },
    watch: {

    },
    beforeDestroy () {
        
    }
})
</script>

<style lang="scss" scoped>
@import '../../styles/app';

.nav-bar {
    .navbar {
        height: $navbar-height !important;

        @include media-breakpoint-down(xs) {
            max-height: ($navbar-height * 0.8) !important;
        }
    }

    .navbar-brand {
        font-size: 1.25rem;
        text-decoration: none;
        white-space: nowrap;
        font-family: $font-alt !important;
    }
    .navbar-brand:hover, .navbar-brand:active {
        color: var(--primary);
    }

    .navbar-light .navbar-nav .nav-link:hover {
        color: var(--primary);
        background-color: var(--secondary);
    }

    .active {
        color: var(--primary);
        background-color: var(--secondary);
        border-bottom: solid 2px !important;
        padding-top: 3px !important;
    }

    .navbar-toggler {
        
    }
}
</style>